module.exports = __webpack_public_path__ + "img/data-sheet_-valimail-defend.8f99c896.png";